import './SearchBar.scss';

const SearchBar = () => {
	return (
		<div>
			<input
				type='text'
				className='searchBar'
				placeholder='Search Here...'
			></input>
		</div>
	);
};

export default SearchBar;
